import { CodeBook } from "@king-ict/eupisi-ui/models";
import { getI18n } from "react-i18next";

import { getFounderInstitutions } from "../../api/Founders/FoundersApi";
import { ClaimType, Role, UserRole } from "../../models/User";
import { FounderCodeBook } from "../../queries/founderQuery";

export const getLocationLabel = (role: Role) => {
  const i18 = getI18n();

  let label = "";
  if ([ClaimType.County, ClaimType.Committee].includes(role.claimTypeId)) {
    label = i18.t("common.schoolCandidateModel.countyList");
  } else if (role.claimTypeId === ClaimType.TownOffice) {
    label = i18.t("common.schoolCandidateModel.municipalityList");
  } else {
    label = i18.t("common.schoolCandidateModel.institutionList");
  }

  return label;
};

export const getUserRole = ({
  role,
  locations = [],
  founders = [],
}: {
  role: Role;
  locations?: CodeBook[];
  founders?: CodeBook[];
}): UserRole => {
  return {
    role: { id: role.id, name: role.name },
    locations,
    founders,
  };
};

export const getRemovedFounder = (
  founders: CodeBook[] | null,
  userLocations: FounderCodeBook[]
) => {
  const removedFounder = founders?.find(
    (prevFounder) =>
      !userLocations.some((newFounder) => newFounder.id === prevFounder.id)
  );

  return removedFounder;
};

export const getLocations = async ({
  typedLocations,
  currentLocations,
  removedFounder,
}: {
  typedLocations: FounderCodeBook[];
  currentLocations: CodeBook[];
  removedFounder?: CodeBook;
}) => {
  // Get new institutions from the added founders
  const newInstitutions = typedLocations.flatMap(
    (location) => location.institutions || []
  );

  let locationsToRemove: number[] = [];
  if (removedFounder) {
    try {
      locationsToRemove = await getFounderInstitutions(removedFounder.id);
    } catch (error) {
      console.error("Error getting founder institutions", error);
    }
  }

  let mergedLocations = [...currentLocations, ...newInstitutions];

  if (locationsToRemove.length) {
    mergedLocations = mergedLocations.filter(
      (location) => !locationsToRemove.includes(location.id)
    );
  }

  return mergedLocations;
};

export const getInstitutionsAndFounders = (
  typedLocations: FounderCodeBook[]
) => {
  const institutions = typedLocations.flatMap(
    (location) => location.institutions
  );
  const founders = typedLocations.map((location) => ({
    id: location.id,
    name: location.name,
  }));

  return { institutions, founders };
};
